import { MockRegistry } from './mock-registry';
import { RequestLog } from './request-log';

export const mockRegistry = new MockRegistry();
export const requestLog = new RequestLog();
